import React, { memo, useRef } from 'react';
import { Game as CommonGame } from '@theme/js/components/common/Game/Game';
import { Loader } from '@core/js/components/common/Loader';
import { useGameCodes } from '@theme/js/components/common/GamesView/hooks';
import { clsx } from '@core/js/utils/classNames.util';

import style from './index.scss';

export default memo(({
    gameCodes,
    showDivider,
    showGameInfo,
    showFeatureIcons = true,
    Game = CommonGame,
    expanded, /* TotalCasino changes */
    categoryName /* TotalCasino changes */
}) => {

    /* TotalCasino changes */
    const parentEl = useRef(null);
    const codes = useGameCodes({
        gameCodes,
        parentEl,
        expanded
    });

    return (
        <div className={style.games} ref={parentEl}>
            <>
                {codes.map(code =>
                    <Game key={code}
                          code={code}
                          withFlexWidth={false}
                          showGameInfo={showGameInfo}
                          className={clsx([style.game, showDivider && style.divider])}
                          showFeatureIcons={showFeatureIcons}
                          categoryName={categoryName} /* TotalCasino changes */
                    />
                )}
                {expanded && codes.length !== gameCodes.length ? <Loader/> : null}
            </>
        </div>
    );
    /* TotalCasino changes */
});
